export default __webpack_public_path__ + "static/media/ban-desktop-image-2.a0b7ce85.jpg";